import TrackingDataContainer from './TrackingDataContainer';

export default TrackingDataContainer;
